// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".like-button:hover .icon-heart-outlined[data-v-7b58d492]:before{content:\"\"}.like-button:hover .icon-heart[data-v-7b58d492]:before{content:\"\"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
